// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    appName: 'Leadbrix',
    appVersion: require('../../package.json').version,
    appLogoImage: require('@src/assets/images/logo/leadbrix_icon_v1.png').default,
    appLogoNameImage: require('@src/assets/images/logo/LeadBrix@4x.png').default,
    appLogoNameImageWidth: 175,
    appLogoNameImageHeight: 40
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static' // static, sticky, hidden
    },
    customizer: false, // customizer button right side
    scrollTop: true // Enable scroll to top button
  }
}

export default themeConfig
